<template>
    <section>
        <div id="order-boat-modal" name="order-boat-modal" class="order-boat-modal" v-if="isModalOpen">
            <div class="modal-card">
                <div class="sushiboat-form">
                    <div class="row">
                        <span>Potato</span>
                        <input class="input-field">
                        <button @click="isModalOpen = !isModalOpen" class="bg-orange px-5 py-10 rounded-lg"> Teste Modal </button>
                    </div>
                </div>
            </div>
        </div>
        <button @click="isModalOpen = !isModalOpen" class="btn"> Teste Modal </button>
    </section>
</template>

<script>
export default {
    data() {
        return {
            isModalOpen: false,
        }
    }
}
</script>
